import _ from 'lodash';

export default function removePropertiesStartingWithDollarSign(obj) {
  if (!_.isPlainObject(obj)) return obj;

  // Retirer les propriétés débutant par $ (limitation de MongoDb)

  return _.mapValues(
    _.omitBy(obj, (value, key) => _.startsWith(key, '$')),
    value =>
      _.isArray(value)
        ? value.map(removePropertiesStartingWithDollarSign)
        : removePropertiesStartingWithDollarSign(value)
  );
}
